﻿export default {
  AIOrderForm: {
    text: 'Shipment Information',
    upload: 'Upload Attachment',
    placehtext: 'Please enter shipment information!',
    placehsteps: '1. Supports images, Excel, Word, PDF, chat records, etc. — paste / drag / upload\n2. Supports Chinese / English / mixed formats\n3. Include: sender/recipient (name, phone, address) and parcel (weight/dimensions)\n4. Click Submit — system auto-recognizes and creates the order\n5. Confirm in AI Order List → click Predict Cost\n6. Select channel → Pay → Print order, shipment complete',
    tuozhuaiwenjian: 'Drag files here, or',
    dianjishangchuan: 'Click to Upload',
    zhichiduogewenjian: 'Support images, Excel and PDF files, up to 9 files',
    ctrlvTip: 'or press Ctrl+V to paste files',
    ctrlvSupport: ', supports Ctrl+V paste upload',
    submit: 'Extract Shipment Details',
    reset: 'Cancel',
    uploadSuccess: 'Upload Successful',
    uploadFail: 'Upload Failed',
    warningTitle: 'Address Recognition Notice',
    warningConfirm: 'Got it, go check'
  },
  address: {
    addAddress: "Add Address",
    serialNumber: "No.",
    realname: "Full Name",
    country: "Country/Region",
    province: "State/Province",
    city: "City",
    address1_2: "Address 1/2",
    mobile: "Phone Number",
    zcode: "ZIP Code",
    email: "Email",
    type: "Address Type",
    senderAddress: "SHP-FOM",
    recipientAddress: "SHP-TO",
    operation: "Operation",
    edit: "Edit",
    delete: "Delete",
    select: "Select",
    confirmDelete: "Confirm deletion?",
    warmTips: "Warm Reminder",
    add: "Add Address",
    editAddress: "Edit Address",
    reset: "Reset",
    query: "Search",
    addressType: "Address Type",
  },
  addressForm: {
    type: "Address Type",
    senderAddress: "SHP-FOM",
    recipientAddress: "SHP-TO",
    realname: "Full Name",
    company: "Company",
    country: "Country/Region",
    province: "State/Province",
    city: "City",
    zcode: "ZIP Code",
    address1: "Address Line 1",
    address2: "Apt, Suite, Unit, etc.",
    address3: "Address 3",
    mobile: "Phone Number",
    email: "Email",
    setDefaultAddress: "Set as default address",
    submit: "Submit",
    reset: "Reset",
    placeholder: {
      selectType: "Please select type",
      inputRealname: "Please enter name",
      inputCompany: "Please enter company",
      selectCountry: "Please select country",
      selectProvince: "Please select state/province",
      inputCity: "Please enter city",
      inputZcode: "Please enter ZIP code",
      inputAddress1: "Please enter address 1",
      inputAddress2: "Please enter address 2",
      inputMobile: "Please enter mobile phone",
      inputEmail: "Please enter email",
    },
    validate: {
      requiredType: "Please select type",
      requiredRealname: "Please enter name",
      requiredAddress1: "Please enter address 1",
      requiredCountry: "Please select country",
      requiredProvince: "Please select state/province",
      requiredCity: "Please enter city",
      requiredZcode: "Please enter ZIP code",
      requiredMobile: "Please enter mobile phone",
    },
  },
  calc: {
    startCountry: "Start Country/Region",
    startZipCode: "Start ZipCode",
    destinationCountry: "Destination Country/Region",
    destinationZipCode: "Destination ZipCode",
    isResidential: "is Residential?",
    unit: {
      lbIn: "lb/in",
      kgCm: "kg/cm",
    },
    weight: {
      lb: "lb",
      oz: "oz",
      ozL: "oz L",
    },
    dimension: {
      length: "L",
      width: "W",
      height: "H",
    },
    packNum: "Package Number",
    filter: {
      all: "All",
      fedex: "FedEx",
    },
    button: {
      getRates: "Get Rates",
      reset: "Reset",
    },
    table: {
      service: "Service",
      packageType: "Package Type",
      rate: "Rate",
      action: "Action",
    },
    validate: {
      requiredStartCountry: "Please select start country",
      requiredStartZipCode: "Please enter start zip code",
      requiredDestinationCountry: "Please select destination country",
      requiredDestinationZipCode: "Please enter destination zip code",
      requiredLb: "Please enter weight",
      requiredLength: "Please enter length",
      requiredWidth: "Please enter width",
      requiredHeight: "Please enter height",
    },
    placeholder: {
      zipCode: "ZipCode",
    },
  },
  facilitator: {
    serialNumber: "No.",
    serviceProvider: "Service Provider",
    serviceProviderDesc: "Service Provider Description",
    title: "Facilitator List", // Optional: Page title text
  },
  finance: {
    invoice: {
      serialNumber: "No.",
      orderNo: "Order Number",
      waybillNo: "Tracking Number",
      createTime: "Create Time",
      operation: "Operation",
      viewInvoice: "View Invoice",
      invoiceList: "Invoice List",
      viewInvoiceTitle: "View Invoice",
      pagination: {
        total: "Total {total} items",
        perPage: "{size} items per page",
        page: "Page {current}",
      },
    },
    credit: {
      serialNumber: "No.",
      changeTime: "Change Time",
      changeMethod: "Change Method",
      changeAmount: "Change Amount",
      amountBeforeChange: "Amount Before Change",
      amountAfterChange: "Amount After Change",
      changeReason: "Change Reason",
      deductionNote: "Deduction Note",
      increase: "Increase",
      deduction: "Deduction",
      startDate: "Start Date",
      endDate: "End Date",
      to: "To",
      placeholder: {
        selectChangeMethod: "Please select change method",
      },
      button: {
        query: "Search",
        reset: "Reset",
        export: "Export",
      },
      title: "Credit Flow",
    },
    consumption: {
      serialNumber: "No.",
      time: "Time",
      type: "Type",
      amount: "Amount",
      currentBalance: "Current Balance",
      logisticsNo: "Tracking Number",
      deductionOrderNo: "Deduction Order No.",
      remark: "Description",
      deductionNote: "Deduction Note",
      startDate: "Start Date",
      endDate: "End Date",
      to: "To",
      typeOptions: {
        // adminRecharge: "Admin Recharge",
        // recharge: "Recharge",
        // consumption: "Consumption",
        // freightDeduction: "Freight Deduction",
        // refund: "Refund",
        adminRecharge: "Manual Credit",
        recharge: "Top-up",
        consumption: "Shipping Charge",
        freightDeduction: "Freight Deduction",
        refund: "Refund",
      },
      shippingCharge: "Shipping Charge",
      placeholder: {
        selectType: "Please select type",
      },
      button: {
        query: "Search",
        reset: "Reset",
        export: "Export",
      },
      title: "Transactions",
    },
    invoiceView: {
      viewInvoice: "View Invoice",
    },
  },
  recharge: {
    title: "Express Recharge",
    balanceLabel: "Current balance",
    amountLabel: "Top-up amount",
    amountPlaceholder: "Enter top-up amount",
    amountTip: "$1 - $50000 per transaction, no fee, credited instantly",
    quick: "Quick amounts",
    methodLabel: "Payment method",
    methodBalance: "Balance",
    methodCard: "Credit card",
    methodWechat: "WeChat Pay",
    methodAlipay: "Alipay",
    methodPaypal: "PayPal",
    confirmBtn: "Confirm top-up",
    amountInvalid: "Please enter a valid amount",
    amountMin: "Minimum top-up amount is $1",
    amountMax: "Maximum top-up amount is $50000",
    payTitle: "Complete payment",
    payCreateShipment: "Review & Pay",
    balanceAvailable: "Available balance",
    payNow: "Pay now",
    paying: "Paying",
    paySuccess: "Top-up successful",
    payFail: "Payment failed, please retry",
    netErr: "Network error, please retry later",
    loadingPay: "Loading payment",
    creatingOrder: "Creating recharge order",
    preparingPayment: "Preparing payment",
    orderRateRequired: "Please get a rate and select a shipping service first",
    scanWechatTip: "Scan with WeChat to pay",
    scanAlipayTip: "Scan with Alipay to pay",
    qrLeft: "Code expires in",
    qrExpired: "QR code expired, please regenerate",
    regenerate: "Regenerate",
    waitingPay: "Waiting for payment",
    close: "Close",
    cancel: "Cancel",
  },
  invoice: {
    invoice: {
      serialNumber: "No.",
      orderNo: "Order Number",
      waybillNo: "Tracking Number",
      createTime: "Create Time",
      operation: "Operation",
      viewInvoice: "View Invoice",
      orderInvoice: "Order Invoice",
      addressType: "Address Type",
      senderAddress: "SHP-FOM",
      recipientAddress: "SHP-TO",
      placeholder: {
        selectAddressType: "Please select address type",
      },
      button: {
        query: "Search",
        reset: "Reset",
      },
    },
    detail: {
      generatePdf: "Download Invoice",
      invoiceTips: "This invoice must be completed in English.",
      proFormaInvoice: "Pro Forma Invoice",
      page: "Page",
      of: "of",
      exporter: "EXPORTER: ",
      taxId: "Tax ID#: ",
      contactName: "Contact Name: ",
      telephoneNo: "Telephone No.: ",
      email: "E-Mail: ",
      companyNameAddress: "Company Name/Address",
      countryTerritory: "Country/Territory: ",
      partiesToTransaction: "parties to Transaction: ",
      related: "Related",
      nonRelated: "Non-Related",
      shipDate: "Ship Date: ",
      airWaybillNo: "Air Waybill No. / Tracking No.",
      invoiceNo: "Invoice No.: ",
      purchaseOrderNo: "Purchase Order No.: ",
      paymentTerms: "Payment Terms: ",
      billOfLading: "Bill of Lading",
      purposeOfShipment: "Purpose of Shipment: ",
      sold: "SOLD",
      consignee: "CONSIGNEE: ",
      soldToImporter: "SOLD TO / IMPORTER (if different from Consignee): ",
      designatedBroker:
        "if three is a designated broker for this shipment, please provide contact infomation.",
      nameOfBroker: "Name of Broker",
      telNo: "Tel.No.",
      contactNameShort: "Contact Name.",
      dutiesAndTaxesPayableBy: "Duties and Taxes Payable by",
      exporter: "Exporter",
      consigneeShort: "Consignee",
      other: "Other",
      ifOtherPleaseSpecify: "if Other, please specify",
      noOfPackages: "No. of Packages",
      noOfUnits: "No. of Units",
      netWeight: "Net Weight",
      lbsKgs: "(LBS / KGS)",
      unitOfMeasure: "Unit of Measure",
      descriptionOfGoods: "Description of Goods",
      harmonizedTariffNumber: "Harmonized Tariff Number",
      countryTerrOfMfr: "Country / Terr. of MFR",
      unitValue: "Unit Value",
      totalValue: "Total Value",
      totalPkgs: "Total Pkgs",
      totalUnits: "Total Units",
      totalNetWeight: "Total Net Weight",
      totalGrossWeight: "Total Gross Weight",
      indicateLbsKgs: "(Indicate LBS/KGS)",
      termsOfSale: "Terms of Sale: ",
      subtotal: "Subtotal: ",
      insurance: "Insurance: ",
      freight: "Freight: ",
      packing: "Packing: ",
      handling: "Handling: ",
      otherFee: "Other: ",
      specialInstructions: "Special Instructions: ",
      declarationStatements: "Declaration Statement(s): ",
      declarationContent:
        "These items are controlled by the U.S. Government and authorized for export only to the country of ultimate destination for use by the ultimate consignee or end-user(s) herein identified. They may not be resold, transferred, or otherwise disposed of, to any other country or to any person other than the authorized ultimate consignee or end-user(s), either in their original form or after being incorporated into other items, without first obtaining approval from the U.S. government or as otherwise authorized by U.S. law and regulations.",
      declareTrueCorrect:
        "I declare that all the information contained in this invoice to be true and correct.",
      originatorOrCompanyRep:
        "Originator or Name of Company Representative if the invoice is being completed on behalf of a company or individual: ",
      invoiceTotal: "Invoice Total: ",
      currencyCode: "Currency Code: ",
      signatureTitleDate: "Signature / Title / Date: ",
      rev: "REV",
    },
  },
  layout: {
    index: {
      calculator: "Calculator", // 弹窗 title
      close: "Close", // Reserved: calculator close button
    },
    side: {
      home: "Home",
      createDomesticWaybill: "Create Domestic Waybill",
      createInternationalWaybill: "Create Intl Waybill",
      expressOrderManagement: "Express Order Mgmt",
      expressAddressManagement: "Express Address Mgmt",
      invoiceList: "Invoice List",
      findStores: "Find Stores",
      ltlOrderManagement: "LTL Order Mgmt",
      orderList: "Order List",
      ltlQuoteManagement: "LTL Quote Mgmt",
      onlineQuote: "Online Quote",
      quoteList: "Quote List",
      fbaQuote: "FBA Quote",
      ltlProductManagement: "LTL Product Mgmt",
      ltlAddressManagement: "LTL Address Mgmt",
      myFinance: "My Finance",
      expressConsumptionFlow: "Transactions",
      expressRecharge: "Express Recharge",
      ltlRechargeManagement: "LTL Recharge Mgmt",
      ltlFinancialDetails: "LTL Financial Details",
      ltlInvoiceManagement: "LTL Invoice Mgmt",
      announcementList: "Announcement List",
      myWorkOrder: "My Work Order",
      serviceProviderList: "Service Provider List",
      accountManagement: "Account Mgmt",
      personalInfo: "Personal Information",
      changePassword: "Change Password",
      // 注释中备用文
      internationalOrder: "Intl Order",
      financialManagement: "Financial Mgmt",
      creditFlow: "Credit Flow",
      memberCenter: "Member Center",
      calculator: "Calculator",
      personalCenter: "Personal Center",
      test: "Test",
      AIOrderForm: 'AI Auto-Fill',
      AIOrderList: 'AI Shipments'
    },
    top: {
      printBalance: "Print Balance: ",
      ltlBalance: "LTL Balance: ",
      logOut: "Log Out",
      noNewNotifications: "No new notification messages~",
      newNotifications: "New Notification Messages", // Reserved: notification title
    },
  },
  stores: {
    pageTitle: "Find Stores",
    pageSubtitle: "Select a country or region and enter a postal code to find nearby FedEx and UPS locations",
    countryPlaceholder: "Select country or region",
    countryRequired: "Please select a country or region",
    countryLoadFailed: "Failed to load the country/region list. Please try again later.",
    zipcodePlaceholder: "Enter postal code",
    zipcodeInvalid: "Enter a valid postal code (up to 10 letters, numbers, spaces, or hyphens)",
    searchBtn: "Search",
    searching: "Searching...",
    fedexTitle: "FedEx Stores",
    upsTitle: "UPS Stores",
    weekHours: "Weekly Hours",
    openAllDay: "Open 24h",
    selfService247: "24/7 Self-Service Drop Box",
    noHours: "Hours not available",
    rest: "Closed",
    services: "Services",
    fedexEmpty: "No FedEx stores in this area",
    upsEmpty: "No UPS stores in this area",
    initialTip: "Select a country or region and enter a postal code above to start",
    notFoundTip: "No stores found, try another ZIP code?",
    quickTry: "Try popular ZIPs:",
    errorPrefix: "Search failed: ",
  },
  login: {
    index: {
      account: "Account",
      password: "Password",
      placeholder: {
        inputAccount: "Please enter account",
        inputPassword: "Please enter password",
      },
      registerAccount: "New to ECPAI? Create an Account",
      login: "Sign In",
      forgetPassword: "Forgot Password",
      accountLogin: "Account Login",
      tempLogin: "Temporary Login",
      requiredMessage: {
        account: "Please enter account",
        password: "Please enter password",
      },
      forgetPasswordTitle: "Forgot Password",
      brandSlogan: "Your AI-Native Logistics Operating System",
      brandDesc: "Let AI handle your shipping operations.",
      assistant247: "24/7 AI Operations Assistant",
      poweredByEva: "Powered by EVA",
    },
    pass: {
      email: "Email",
      verificationCode: "Verification Code",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      placeholder: {
        inputEmail: "Enter the email associated with your ECPAI account.",
        inputCode: "Enter verification code",
        inputNewPassword: "Enter a new password",
        inputConfirmPassword: "Confirm your new password",
      },
      getCode: "Send Verification Code",
      codeSent: "A verification code has been sent to your email.",
      sendingCode: "Sending...",
      getCodeCountdown: "Resend({0})",
      submit: "Reset Password",
      reset: "Reset",
      resetSuccess: "Your password has been reset successfully.",
      requestFailed: "Request failed. Please try again later.",
      requiredMessage: {
        email: "Enter the email associated with your ECPAI account.",
        captcha: "Enter verification code",
        newPassword: "Enter a new password",
        confirmPassword: "Confirm your new password",
      },
      formatMessage: {
        email: "Incorrect email format",
        captcha: "Incorrect verification code format",
        passwordLength: "Password must be at least 6 characters",
        passwordNotMatch: "The two passwords do not match",
      },
    },
  },
  register: {
    account: "Email",
    phoneNumber: "Phone Number",
    password: "Password",
    confirmPassword: "Confirm Password",
    verificationCode: "Verification Code",
    getCode: "Send Verification Code",
    getCodeCountdown: "Resend in {0}s",
    placeholder: {
      inputAccount: "Please enter email",
      inputEmail: "Enter your email",
      inputPhone: "Enter your phone number",
      inputPassword: "Enter your password",
      inputConfirmPassword: "Enter your password again",
      inputCode: "Enter verification code",
    },
    login: "Already have an account? Sign In",
    register: "Create Account",
    registerAccount: "Create your ECPAI account", // Reserved comment text
    brandSlogan: "Your AI-Native Logistics Operating System",
    brandDesc: "Let AI handle your shipping operations.",
    assistant247: "24/7 AI Operations Assistant",
    poweredByEva: "Powered by EVA",
    consentPrefix: "I have read and agree to the ",
    terms: "Terms of Service",
    consentMiddle: " and acknowledge the ",
    privacy: "Privacy Policy",
    consentSuffix: ".",
    consentText: "I have read and agree to the Terms of Service and acknowledge the Privacy Policy.",
    consentRequired: "Please read and agree to the Terms of Service and Privacy Policy",
    legalCopyright: "© 2026 ZD WORLD INC. ECPAI is a brand owned and operated by ZD WORLD INC.",
    prohibited: "Prohibited Items Policy",
    requiredMessage: {
      account: "Please enter email",
      code: "Please enter verification code",
      phone: "Please enter phone number",
      newPassword: "Please enter new password",
      reEnterPassword: "Please enter password again",
      passwordNotMatch: "The two passwords entered are inconsistent!",
    },
    formatMessage: {
      phone: "Incorrect phone number format", // Reserved comment text
      email: "Incorrect email format",
    },
  },
  user: {
    password: {
      oldPassword: "Old Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      placeholder: {
        inputOldPassword: "Please enter old password",
        inputNewPassword: "Please enter new password",
        inputConfirmPassword: "Please enter confirm password",
      },
      submit: "Submit",
      reset: "Reset",
      requiredMessage: {
        oldPassword: "Please enter old password",
        newPassword: "Please enter new password",
        reEnterPassword: "Please enter password again",
        passwordNotMatch: "The two passwords entered are inconsistent!",
      },
    },
    member: {
      memberName: "Member Name",
      personalProfile: "Personal Profile",
      remainingAmount: "Remaining Amount",
      totalPoints: "Total Points",
      loginTime: "Login Time",
      lastLogin: "Last Login",
    },
    info: {
      personalInfo: "Personal Information",
      loginUser: "Login User: ",
      balance: "Balance: ", // Reserved comment text
      basicInfo: "Basic Information",
      username: "Username",
      nickname: "Display Name",
      email: "Email",
      contactInfo: "Phone Number",
      placeholder: {
        inputNickname: "Please enter display name",
        inputEmail: "Please enter email",
        inputContact: "Please enter contact information",
      },
      confirm: "Save Changes",
      editEmail: "Edit Email",
      editPhone: "Edit Phone Number",
    },
    agreement: {
      content1:
        'Welcome to use the Adapay Platform Agreement Payment Service, which is provided to you by Shanghai Huifu Data Service Co., Ltd. (the "Company"). Before accepting this Service Agreement, please fully read and understand all the contents of this Agreement. Your completion of the click confirmation operation through the platform page indicates that both parties have entered into this Agreement. You warrant that you have full civil capacity for rights and civil capacity for conduct as stipulated by law, and are capable of independently assuming civil liabilities. You have fully read, understood and accepted all the agreed contents of this Agreement. If you do not meet the above requirements, do not agree to the contents of this Agreement, or cannot accurately understand the meaning of relevant clauses, you shall immediately stop subsequent operations and contact the Company in a timely manner. For the cooperation between the two parties that has actually been carried out, the Company will suspend it, and the signed relevant product cooperation agreements shall be deemed terminated. The signing time of this Agreement shall be subject to the display on the Company\'s system.',
      content2:
        "You agree that the Company has the right to modify the contents of this Agreement and announce it in the form of a notice on this interface without separate notification; if you continue to cooperate with the Company after the Company announces the modification of the Agreement contents, it means that you have fully read, understood and accepted the modified Agreement contents; if you do not agree to the modified Agreement contents or cannot accurately understand the meaning of relevant clauses, you shall immediately stop subsequent operations and contact the Company in a timely manner. For the cooperation between the two parties that has actually been carried out, the Company will suspend it, and the signed relevant product cooperation agreements shall be deemed terminated.",
      content3:
        "The Company has taken reasonable measures to draw your attention to all the clauses of this Agreement and has fully explained its contents. You voluntarily exercise your rights and perform your obligations in accordance with the provisions of this Agreement.",
      title1: "I. Rights and Obligations",
      item1_1:
        "1. You warrant that you are the holder of the bank card used for this Service, and that you can use the bank card legally and effectively without infringing upon the legitimate rights and interests of any third party. Otherwise, you shall be liable for compensation and assume legal liabilities for any losses caused to the Company and the cardholder thereby.",
      item1_2:
        "2. You shall ensure that the mobile phone number provided for opening this Service is owned by you. To this end, you understand and agree that the Company will verify the authenticity and validity of the mobile phone number provided by you through third-party channels.",
      item1_3:
        "3. To prevent transaction risks and protect the security of your funds, you understand and agree that the Company will use the information provided by you, such as: name, ID card number, mobile phone number, bank card information (card number, validity period, card verification code, etc.) and reserved mobile phone number, to conduct cross-verification with the issuing bank.",
      item1_4:
        "4. For the purpose of providing this Service, you authorize the Company to collect your personal information such as name, ID card number, mobile phone number, bank card information (card number, validity period, card verification code, etc.); the Company attaches great importance to the processing and protection of personal information, and will collect your personal information in accordance with the principles of legality, legitimacy and necessity and strictly protect your personal information.",
      item1_5:
        "5. You shall properly keep the bank card, card number, password, mobile phone number reserved by the issuing bank, digital certificate, mobile dynamic password, verification code and other information and equipment related to the bank card. If you lose or disclose the aforementioned information and/or equipment, you shall promptly notify the issuing bank and/or the Company. Regardless of whether you have notified the issuing bank and/or the Company, you shall bear the losses caused by your own reasons.",
      item1_6:
        "6. When using this Service, you shall carefully confirm the transaction information, including but not limited to the commodity name, quantity, amount, etc. You acknowledge and agree that the instructions you issue are irrevocable, and the Company will deduct funds from the bank card to the payee in accordance with your instructions. You shall not require the Company to assume any liability on the grounds of unauthorized transactions or other reasons.",
      item1_7:
        "7. You shall be responsible for the authenticity and validity of the instructions issued during the use of this Service, and you shall bear the risks of the Company's operations in accordance with your instructions. Transaction data shall be subject to the records of the Company.",
      item1_8:
        "8. You warrant that the personal information provided by you when using this Service is true, legal, valid, complete and accurate. The Company will provide corresponding services to you in accordance with the relevant information set by you. If the information set by you is incorrect, you shall bear the corresponding liabilities and risks by yourself.",
      item1_9:
        "9. You agree that the Company will retain your transaction records to meet the requirements of anti-money laundering and supervision. During the period when you use this Service and after the termination of this Service, you understand and agree that the Company will retain the relevant information provided by you or newly generated during the use of this Service within the time limit required by relevant laws, regulations or supervision.",
      item1_10:
        "10. The Company has the right to immediately terminate your use of this Service without assuming any liability if any of the following circumstances occurs: (1) Using this Service for illegal purposes; (2) Violating the provisions of this Agreement; (3) The Company deems that there are transaction risks in providing this Service to you; (4) Your bank card is invalid, expired or cancelled.",
      title2: "II. Applicable Law and Dispute Resolution",
      item2_1:
        "1. All matters such as the interpretation, application and dispute resolution of this Agreement shall be governed by the laws of the People's Republic of China (excluding the laws of the Hong Kong Special Administrative Region, Macao Special Administrative Region and Taiwan Region), excluding conflict of laws rules.",
      item2_2:
        "2. In case of any dispute arising from this Agreement, all parties shall negotiate in good faith. If the negotiation fails, all parties shall submit the dispute to the people's court with jurisdiction at the Company's domicile for litigation resolution, and the litigation costs (including attorney fees, notarization fees, etc.) shall be borne by the losing party.",
    },
    phone: {
      newPhoneNumber: "New Phone Number",
      verificationCode: "Verification Code",
      placeholder: {
        inputPhone: "Please enter phone number",
        inputCode: "Please enter verification code",
      },
      getCode: "Get Code",
      getCodeCountdown: "Get Code({0})",
      submit: "Submit",
      reset: "Reset",
      requiredMessage: {
        phone: "Please enter phone number",
        smsCode: "Please enter verification code",
      },
      formatMessage: {
        phone: "Incorrect phone number format",
        smsCode: "Incorrect verification code format",
      },
    },
    email: {
      newEmail: "New Email",
      verificationCode: "Verification Code",
      placeholder: {
        inputEmail: "Please enter new email",
        inputCode: "Please enter verification code",
      },
      getCode: "Get Code",
      getCodeCountdown: "Get Code({0})",
      submit: "Submit",
      reset: "Reset",
      requiredMessage: {
        email: "Please enter email",
        smsCode: "Please enter verification code",
      },
      formatMessage: {
        email: "Incorrect email format",
        smsCode: "Incorrect verification code format",
      },
    },
  },
  order: {
    place: {
      title: {
        shipperInfo: "Shipper Information",
        consigneeInfo: "Consignee Information",
        cargoGoods: "Cargo/Goods",
        scheduledPickup: "Scheduled Pickup",
        packagingInfo: "Packaging Info",
        packageInfo: "Package Information",
        selectSenderAddress: "Select SHP-FOM",
        selectFbaAddress: "Select FBA Address",
        selectReceiverAddress: "Select Receiver Address",
      },
      label: {
        name: "Full Name",
        company: "Company",
        country: "Country/Region",
        stateProvince: "State",
        city: "City",
        zipCode: "Zip Code",
        address1: "Address 1",
        address2: "Address 2",
        address3: "Address 3",
        phone: "Phone Number",
        email: "Email",
        logisticsChannel: "Logi Ch",
        ecommerceOrderNo: "EC Order No.",
        labelRemark: "WB Note",
        remarks: "Shipment Notes",
        shipDate: "Ship Date",
        signatureRequired: "Signature Option",
        packageType: "Package Type",
        sku: "SKU (Optional)",
        packageQuantity: "Number of Packages",
        dimensions: "Dimensions",
        weight: "Weight",
        declaredValue: "Declared Value (USD)",
        totalPackages: "Total Packages",
        totalWeight: "Total Weight",
        pickupDate: "Pickup Date",
        readyTime: "Ready Time",
        latestTime: "Latest Time",
        specialInstructions: "Special Instructions",
      },
      placeholder: {
        enterName: "Please enter name",
        enterCompany: "Please enter company",
        selectCountry: "Please select country",
        selectState: "Please select state/province",
        enterCity: "Please enter city",
        enterZipCode: "Please enter zip code",
        enterAddress1: "Please enter address 1",
        enterAddress2: "Please enter address 2",
        enterAddress3: "Please enter address 3",
        enterPhone: "Please enter phone",
        enterEmail: "Please enter email",
        selectLogisticsChannel: "Please select Logi Ch",
        enterEcommerceOrderNo: "Please enter EC Order No.",
        enterLabelRemark: "Please enter WB Note",
        enterRemarks: "Please enter remarks",
        selectShipDate: "Please select ship date",
        selectSignature: "Please select signature option",
        selectPackageType: "Please select package type",
        enterSku: "Please enter SKU",
        enterPackageQuantity: "Please enter quantity",
        enterDimensions: "Please enter dimensions",
        enterWeight: "Please enter weight",
        enterTotalPackages: "Please enter total packages",
        enterTotalWeight: "Please enter total weight",
        selectPickupDate: "Please select pickup date",
        selectReadyTime: "Please select ready time",
        selectLatestTime: "Please select latest available time",
        enterSpecialInstructions: "Please enter special instructions",
      },
      button: {
        clear: "Clear Form",
        saveToAddressBook: "Save to Address Book",
        verifyAddress: "Verify Address",
        swapAddress: "Swap Addresses",
        predictRate: "Confirm",
        saveDraft: "Save Draft",
        generateOrder: "Generate Shipping Order",
        storeShipment: "Create In-Store Shipment",
        reset: "Reset",
        copyPackage: "Copy Package",
      },
      options: {
        signature: {
          // noSignature: "No Signature",
          // adultSignature: "Adult Sig Req",
          // standardSignature: "Standard Signature",
          noSignature: "No Signature Required",
          adultSignature: "Adult Signature",
          standardSignature: "Standard Signature",
        },
      },
      unit: {
        lbIn: "lb/in",
        kgCm: "kg/cm",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "kg",
        currency: "$",
      },
      pa_unit: "lb/in",
      tips: {
        weightDimensions: "Tip: Package weight and dimensions directly affect shipping costs",
      },
      validation: {
        enterShipperName: "Please enter shipper name",
        selectShipperCountry: "Please select shipper country",
        selectShipperState: "Please select shipper state/province",
        enterShipperCity: "Please enter shipper city",
        enterShipperZip: "Please enter shipper zip code",
        enterShipperAddress: "Please enter shipper address",
        enterShipperPhone: "Please enter shipper phone",
        enterConsigneeName: "Please enter consignee name",
        selectConsigneeCountry: "Please select consignee country",
        selectConsigneeState: "Please select consignee state/province",
        enterConsigneeCity: "Please enter consignee city",
        enterConsigneeZip: "Please enter consignee zip code",
        enterConsigneeAddress: "Please enter consignee address",
        enterConsigneePhone: "Please enter consignee phone",
        selectLogisticsChannel: "Please select Logi Ch",
        enterPickupName: "Please enter pickup contact name",
        selectPickupCountry: "Please select pickup country",
        selectPickupState: "Please select pickup state/province",
        enterPickupCity: "Please enter pickup city",
        enterPickupZip: "Please enter pickup zip code",
        enterPickupAddress: "Please enter pickup address",
        enterPickupPhone: "Please enter pickup phone",
        selectPackageType: "Please select package type",
        enterTotalPackages: "Please enter total packages",
        enterTotalWeight: "Please enter total weight",
        selectPickupDate: "Please select pickup date",
        selectReadyTime: "Please select ready time",
        selectLatestTime: "Please select latest available time",
        enterSku: "Please enter SKU",
        enterPackageQuantity: "Please enter Pkg Qty",
        enterWeight: "Please enter weight",
        enterDimensions: "Please enter dimensions",
      },
      dialog: {
        predictCost: "Predict Cost",
        verifyResult: "Verification Result",
      },
      message: {
        predictFailed: "Failed to predict rate!",
        createOrderFailed: "Failed to create order!",
        saveDraftFailed: "Failed to save draft!",
      },
      ratePrediction: {
        costPrediction: "Cost Prediction:",
      },
    },
    list: {
      tabAll: "All",
      tabWaitPrint: "Ready to Print",
      tabWaitShip: "Ready to Ship",
      tabShipped: "Shipped",
      tabCancelled: "Cancelled",
      tabRefunded: "Refunded",
    },
    check: {
      checkTip: "After verification, Type: ",
      businessAddr: "Business Address",
      residentialAddr: "Residential Address",
      confirmBtn: "Confirm",
    },
    errmsg: {
      confirmBtn: "Confirm",
    },
    free: {
      select: "Select",
      serialNo: "No.",
      logisticsProduct: "Logistics Product",
      totalFreight: "Total Freight",
      fuelSurcharge: "Fuel",
      insuranceFee: "Insurance",
      weight: "Weight",
      deliveryDays: "ETA",
      residentialFee: "Residential",
      ahsFee: "AHS",
      osFee: "OS",
      pickupFee: "Scheduled Pickup Fee",
      otherFee: "Other",
      // serviceNotSupport: "This channel service is not supported",
      serviceNotSupport: "This shipping service is not supported",
      failReason: "Failure Reason",
      failReasonTip: "This channel returned 0. Hover to view the failure reason.",
      bestPrice: "Best Price: ",
      rmbExchange: "Converted to RMB: ",
      confirmBtn: "Confirm",
    },
    rateProgress: {
      title: "Getting Rates",
      subtitle: "Comparing rates from available carriers…",
      completed: "{done} of {total} services checked",
      statusPending: "Waiting",
      statusLoading: "Calculating",
      statusDone: "Rate Received",
      statusFail: "Failed",
    },
    importEx: {
      file: "File",
      selectFile: "Select File",
      templateDownload: "Template Download",
      template: "Import Template",
      fedexTemplate: "FedEx Import Template",
      upsTemplate: "UPS Import Template",
      importTip: "Import Notification",
      pleaseSelectProvider: "Please select provider",
      provider: "Provider",
    },
    morePds: {
      pdfLink: "PDF Link: ",
      confirmBtn: "Confirm",
    },
    orderList: {
      countryStateProvince: "Province",
      receiveAddress: "SHP-TO",
      receiveAddressName: 'Recipient Name',
      receiveAddressNameY: 'Please enter recipient name',
      receivePhone: "Phone",
      ecommerceOrderNo: "EC Order No.",
      logisticsOrderNo: "Logi No.",
      createTime: "Time",
      startDate: "Start Date",
      endDate: "End Date",
      query: "Search",
      reset: "Reset",
      batchCreateWaybill: "Batch Create Waybill",
      batchEstimateFreight: "Batch Estimate Freight",
      batchDelete: "Batch Delete",
      batchCancelOrder: "Batch Cancel Order",
      exportData: "Export Data",
      batchPrint: "Batch Print",
      importOrder: "Import Order",
      batchVerifyAddress: "Batch Verify Address",
      serialNo: "No.",
      orderNo: "Order Number",
      addressType: "Address Type",
      residential: "Residential",
      business: "Business",
      logisticsInfo: "Logistics Info",
      logisticsNo: "Tracking Number",
      logisticsProvider: "Logistics Provider",
      packageCount: "Number of Packages",
      weight: "Weight",
      cost: "Cost",
      deductionAmount: "Deduction Amount",
      fuelFee: "Fuel Fee",
      remoteFee: "Remote Fee",
      residentialFee: "Residential Fee",
      insuranceAmount: "Insurance Amount",
      recipient: "Recipient",
      country: "Country/Region",
      stateProvince: "State/Province",
      address: "Address",
      name: "Name",
      phone: "Phone",
      postalCode: "Postal Code",
      createDate: "Creation Date",
      verificationStatus: "Verification Status",
      isMultiPackage: "Multi-package",
      isSignature: "Sig Req",
      yes: "Yes",
      no: "No",
      isInternational: "International Order",
      isScheduledPickup: "Scheduled Pickup",
      pickupFailed: "Pickup booking failed",
      pickupConfirmationCode: "Pickup Confirmation Code",
      operation: "Operation",
      copyAsNewOrder: "Repeat Shipment",
      pdfFile: "PDF File",
      viewInvoice: "View Invoice",
      barcode: "Barcode",
      packageInfo: "Package Info",
      getWaybill: "Get Waybill",
      viewStoreShippingOrder: "View Store Shipping Order",
      confirmPrintSelected: "Confirm to print selected orders?",
      confirmDeleteSelected: "Confirm to delete selected orders?",
      confirmVerifySelectedAddress: "Confirm to verify selected orders' address?",
      confirmCancelSelected: "Confirm to cancel selected orders?",
      confirmCreateWaybill: "Confirm to create waybills for selected?",
      confirmEstimateFreight: "Confirm to estimate freight for selected?",
      warmTip: "Warm Tip",
      copySuccess: "Copy Successful",
      getWaybillFail: "Failed to get waybill!",
      loadingLabelInvoice: "Generating label and invoice, please wait...",
      batchPrintTitle: "Batch Print",
      viewStoreShippingOrderTitle: "View Store Shipping Order",
      viewPdfFileTitle: "View PDF File",
      viewBarcodeTitle: "View Barcode",
      viewPackageInfoTitle: "View Package Info",
      waybillTitle: "Waybill",
      estimateFreightTitle: "Estimate Freight",
      editTitle: "Edit",
      importOrderTitle: "Import Order",
      verificationResultTitle: "Verification Result",
      orderInvoiceTitle: "Order Invoice",
      batchSearchPlaceholder: "Batch search logistics no./order no.",
      enterReceiveAddress: "Please enter SHP-TO",
      enterReceivePhone: "Please enter recipient phone",
      enterEcommerceOrderNo: "Please enter EC Order No.",
    },
    pickup: {
      btn: "Schedule Pickup",
      title: "Schedule Pickup",
      tipFee: "$24 will be charged for this pickup. Each re-booking is charged again.",
      tipTimeWindow: "Pickup window: close time must be at least 2 hours after ready time, and not earlier than 12:00 pm, otherwise the carrier will reject the booking.",
      reuseSender: "Reuse Sender Info",
      sourceInfo: "Pickup Source",
      packageInfo: "Package Info",
      labelName: "Name",
      labelCompany: "Company",
      labelCountry: "Country",
      labelProvince: "State/Province",
      labelCity: "City",
      labelZcode: "Zip Code",
      labelAddress1: "Address 1",
      labelAddress2: "Address 2",
      labelMobile: "Phone",
      labelTotalPackages: "Total Packages",
      labelTotalWeight: "Total Weight (lbs)",
      labelPickupDate: "Pickup Date",
      labelReadyTime: "Ready Time",
      labelLatestTime: "Close Time",
      labelRemark: "Special Instruction",
      placeholderName: "Please enter name",
      placeholderCompany: "Please enter company",
      placeholderCountry: "Please select country",
      placeholderProvince: "Please select state/province",
      placeholderCity: "Please enter city",
      placeholderZcode: "Please enter zip code",
      placeholderAddress1: "Please enter address 1",
      placeholderAddress2: "Please enter address 2",
      placeholderMobile: "Please enter phone",
      placeholderTotalPackages: "Please enter total packages",
      placeholderTotalWeight: "Please enter total weight",
      placeholderPickupDate: "Please select pickup date",
      placeholderReadyTime: "Please select ready time",
      placeholderLatestTime: "Please select close time",
      placeholderRemark: "Please enter special instruction",
      submit: "Confirm & Pay",
      cancel: "Cancel",
      confirmTitle: "Tip",
      confirmContent: "$24 will be charged for this pickup. Re-booking will be charged again. Continue?",
      success: "Pickup scheduled successfully",
      statusBooked: "Booked",
      statusFailed: "Failed",
      statusNone: "Not booked",
      historyTitle: "Pickup History",
      colDate: "Submitted",
      colPRN: "Confirmation",
      colStatus: "Status",
      colMoney: "Fee",
      colMsg: "Remark",
      errWindowTooShort: "Close time must be at least 2 hours after ready time",
      errCloseTooEarly: "Close time cannot be earlier than 12:00 pm",
      errTodayTooLate: "When pickup date is today, ready time must be at least 2 hours from now. Please select tomorrow.",
    },
    parcel: {
      serialNo: "No.",
      logisticsNo: "Logistics No.",
      size: "Size",
      weight: "Weight",
      inch: "in",
      centimeter: "cm",
      pound: "lb",
      kilogram: "kg",
      totalWeight: "Total Weight",
      totalVolumeWeight: "Total Volumetric Weight",
    },
    fplace: {
      title: {
        shipperInfo: "Shipper Information",
        consigneeInfo: "Consignee Information",
        cargoGoods: "Cargo/Goods",
        scheduledPickup: "Scheduled Pickup",
        packagingInfo: "Packaging Info",
        packageInfo: "Package Information",
        declaredItems: "Declared Items",
      },
      label: {
        name: "Name",
        company: "Company",
        country: "Country/Region",
        stateProvince: "State/Province",
        city: "City",
        zipCode: "Zip Code",
        address1: "Address 1",
        address2: "Address 2",
        address3: "Address 3",
        phone: "Phone",
        email: "Email",
        logisticsChannel: "Logi Ch",
        ecommerceOrderNo: "EC Order No.",
        labelRemark: "WB Note",
        remarks: "Remarks",
        shipDate: "Ship Date",
        signatureRequired: "Sig Req",
        bookingConfirmationNumber: "Freight Booking No.",
        packageType: "Package Type",
        sku: "SKU",
        packageQuantity: "Pkg Qty",
        dimensions: "(L*W*H)",
        weight: "Weight",
        declaredValue: "Declared Value",
        itemQtyValue: "Qty/I",
        customsCode: "Customs Code",
        unitOfMeasure: "Unit of Measure",
        productValue: "Product Value",
        productDescription: "Product Description",
        quantity: "Quantity",
        netWeight: "Net Weight",
        origin: "Country of Origin",
        packageContent: "Package Content",
        packageContentOption: "Content Option",
        totalPackages: "Total Packages",
        totalWeight: "Total Weight",
        pickupDate: "Pickup Date",
        readyTime: "Ready Time",
        latestTime: "Latest Time",
        specialInstructions: "Special Instructions",
      },
      placeholder: {
        enterName: "Please enter name",
        enterCompany: "Please enter company",
        selectCountry: "Please select country",
        selectState: "Please select state/province",
        enterCity: "Please enter city",
        enterZipCode: "Please enter zip code",
        enterAddress1: "Please enter address 1",
        enterAddress2: "Please enter address 2",
        enterAddress3: "Please enter address 3",
        enterPhone: "Please enter phone",
        enterEmail: "Please enter email",
        selectLogisticsChannel: "Please select Logi Ch",
        enterEcommerceOrderNo: "Please enter EC Order No.",
        enterLabelRemark: "Please enter WB Note",
        enterRemarks: "Please enter remarks",
        selectShipDate: "Please select ship date",
        selectSignature: "Please select signature option",
        enterBookingConfirmationNumber: "FedEx freight requires phone booking first; enter booking no. (optional)",
        selectPackageType: "Please select package type",
        enterSku: "Please enter SKU",
        enterQuantity: "Please enter quantity",
        enterDimensions: "Please enter dimensions",
        enterWeight: "Please enter weight",
        enterCustomsCode: "Please enter customs code",
        selectUnit: "Please select",
        enterProductValue: "Please enter product value",
        enterProductDescription: "Please enter product description",
        enterNetWeight: "Please enter net weight",
        selectOrigin: "Please select",
        selectPackageContent: "Please select package content",
        selectContentOption: "Please select",
        enterTotalPackages: "Please enter total packages",
        enterTotalWeight: "Please enter total weight",
        selectPickupDate: "Please select pickup date",
        selectReadyTime: "Please select ready time",
        selectLatestTime: "Please select latest available time",
        enterSpecialInstructions: "Please enter special instructions",
        selectSenderAddress: "Select SHP-FOM",
        selectFbaAddress: "Select FBA address",
        selectReceiverAddress: "Select receiver address",
      },
      button: {
        clear: "Clear",
        saveToAddressBook: "Save to Address Book",
        verifyAddress: "Verify Address",
        swapAddress: "Swap",
        predictRate: "Confirm",
        saveDraft: "Save Draft",
        generateOrder: "Generate Shipping Order",
        storeShipment: "Store Shipment",
        reset: "Reset",
        copyPackage: "Copy Package",
      },
      options: {
        signature: {
          // noSignature: "No Signature",
          // adultSignature: "Adult Sig Req",
          // standardSignature: "Standard Signature",
          noSignature: "No Signature Required",
          adultSignature: "Adult Signature",
          standardSignature: "Standard Signature",
        },
        packageContent: {
          item: "Item",
          document: "Document",
        },
        itemTypes: {
          commercial: "Commercial",
          gift: "Gift",
          sample: "Sample",
          repairReturn: "Repair and Return",
          personalEffects: "Personal Effects",
          personalUse: "Personal Use",
        },
        documentTypes: {
          personal: "Personal Document (e.g. letter)",
          interoffice: "Interoffice Document (e.g. memo)",
          business: "Business Document (e.g. contract)",
          other: "Other",
        },
      },
      unit: {
        lbIn: "lb/in",
        kgCm: "kg/cm",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "kg",
        currency: "$",
      },
      pa_unit: "lb/in",
      tips: {
        weightDimensions: "Tip: Package weight and dimensions directly affect shipping costs",
      },
      validation: {
        enterShipperName: "Please enter shipper name",
        selectShipperCountry: "Please select shipper country",
        selectShipperState: "Please select shipper state/province",
        enterShipperCity: "Please enter shipper city",
        enterShipperZip: "Please enter shipper zip code",
        enterShipperAddress: "Please enter shipper address",
        enterShipperPhone: "Please enter shipper phone",
        enterConsigneeName: "Please enter consignee name",
        selectConsigneeCountry: "Please select consignee country",
        selectConsigneeState: "Please select consignee state/province",
        enterConsigneeCity: "Please enter consignee city",
        enterConsigneeZip: "Please enter consignee zip code",
        enterConsigneeAddress: "Please enter consignee address",
        enterConsigneePhone: "Please enter consignee phone",
        selectLogisticsChannel: "Please select Logi Ch",
        enterPickupName: "Please enter pickup contact name",
        selectPickupCountry: "Please select pickup country",
        selectPickupState: "Please select pickup state/province",
        enterPickupCity: "Please enter pickup city",
        enterPickupZip: "Please enter pickup zip code",
        enterPickupAddress: "Please enter pickup address",
        enterPickupPhone: "Please enter pickup phone",
        selectPackageType: "Please select package type",
        enterTotalPackages: "Please enter total packages",
        enterTotalWeight: "Please enter total weight",
        selectPickupDate: "Please select pickup date",
        selectReadyTime: "Please select ready time",
        selectLatestTime: "Please select latest available time",
        enterCustomsCode: "Please enter customs code",
        customsCodeFormat: "Customs (HS) code must be 6-10 digits (e.g. 610910)",
        enterUnit: "Please enter unit of measure",
        enterProductValue: "Please enter product value",
        enterProductDescription: "Please enter product description",
        enterPackageKind: "Please enter package kind",
        enterQuantity: "Please enter quantity",
        enterNetWeight: "Please enter net weight",
        enterOrigin: "Please enter country of origin",
        selectPackageContent: "Please select package content",
        selectContentOption: "Please select content option",
        enterSku: "Please enter SKU",
        enterPackageQuantity: "Please enter Pkg Qty",
        enterWeight: "Please enter weight",
        enterDimensions: "Please enter dimensions",
      },
      dialog: {
        predictCost: "Predict Cost",
        verifyResult: "Verification Result",
      },
      message: {
        predictFailed: "Failed to predict rate!",
        createOrderFailed: "Failed to create order!",
        saveDraftFailed: "Failed to save draft!",
      },
      resolution: {
        jiexidizhi: "Paste & Parse Address",
        guanbi: "Close",
        tijiao: "Parse & Fill",
        dizhi:"Please fill in the following format:\n1. Line 1: Full Name\n2. Line 2: Phone Number\n3. Line 3: Address,City,State Zip Code",
        dizhibk: "Address cannot be empty",
        dizhigeshi:"Invalid address format! Please fill in the following format:\n1. Line 1: Full Name\n2. Line 2: Phone Number\n3. Line 3: Address,City,State Zip Code",
        xingming: "Full name cannot be empty!",
        dianhua: "Phone number cannot be empty!",
        dizhihang: "Invalid address line format! Must be: Address,City,State Zip Code",
        dizhikhang: "Address, City, State, Zip Code cannot be empty!",
        meiguozhou: "Please enter a valid US state name",
      },
    },
  },
  components: {
    calc: {
      zipCode: "ZipCode",
      isResidential: "is Residential?",
      unit: "Unit",
      lbInch: "lb/in",
      kgCm: "kg/cm",
      weight: "Weight",
      oz: "oz",
      length: "L",
      width: "W",
      height: "H",
      parcelNum: "Parcel Qty",
      searchType: "Search Type",
      all: "All",
      getRates: "Get Rates",
      reset: "Reset",
      service: "Service",
      packageType: "Package Type",
      rate: "Rate",
      action: "Action",
      shipFrom: "Route",
      packageInfo: "Package",
      from: "From",
      to: "To",
      useThis: "Use",
      emptyText: "Fill in the information and click \"Get Rates\"",
      pleaseSelectShipCountry: "Please select shipping country",
      pleaseEnterShipZipCode: "Please enter shipping zip code",
      pleaseSelectReceiveCountry: "Please select receiving country",
      pleaseEnterReceiveZipCode: "Please enter receiving zip code",
      pleaseEnterWeight: "Please enter weight",
      pleaseEnterLength: "Please enter length",
      pleaseEnterWidth: "Please enter width",
      pleaseEnterHeight: "Please enter height",
    },
    message: {
      latestNotice: "Latest Notices",
      noticeDetail: "Notice Details",
      viewDetail: "View Details",
      close: "Close",
    },
    tip: {
      followWechat: "Follow WeChat",
      backToTop: "Back to Top",
    },
  },
  ltluser: {
    personalInfo: "Personal Information",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone Number",
    phoneExt: "Phone Extension",
    companyInfo: "Company Information",
    companyName: "Company Name",
    companyAddress: "Company Address",
    businessLicense: "Business License",
    password: "Password",
    currentPwd: "Current Password",
    newPwd: "New Password",
    confirmPwd: "Confirm Password",
    confirm: "Confirm",
    pleaseEnterFirstName: "Please enter first name",
    pleaseEnterLastName: "Please enter last name",
    pleaseEnterPhone: "Please enter phone number",
    pleaseEnterPhoneExt: "Please enter phone extension",
    pleaseEnterCompanyName: "Please enter company name",
    pleaseEnterCompanyAddress: "Please enter company address",
    pleaseEnterCurrentPwd: "Please enter current password",
    pleaseEnterNewPwd: "Please enter new password",
    pleaseEnterConfirmPwd: "Please enter confirm password",
    uploadSizeLimit: "The size of the uploaded image cannot exceed 10MB!",
  },
  ltlindex: {
    ltlOrderMgmt: "LTL Order Management",
    ltlRateMgmt: "LTL Rate Management",
    ltlAddressMgmt: "LTL Address Management",
    expressOrderMgmt: "Express Order Management",
    expressAddressMgmt: "Express Address Management",
    personalCenter: "Personal Center",
  },
  ltlwork: {
    list: {
      myWorkOrder: "My Work Orders",
      workOrderNo: "Order No.",
      workOrderStatus: "Status",
      inProgress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
      replied: "Replied",
      search: "Search",
      reset: "Reset",
      addWorkOrder: "Add Work Order",
      serialNo: "No.",
      workOrderTitle: "Work Order Title",
      description: "Description",
      createTime: "Create Time",
      operation: "Operation",
      view: "View",
      addWorkOrderDialog: "Add Work Order",
      workOrderDetail: "Work Order Detail",
      pleaseEnterWorkOrderNo: "Please enter work order no.",
      pleaseSelectWorkOrderStatus: "Please select work order status",
    },
    form: {
      workOrderTitle: "Order Title",
      orderNo: "Order No.",
      description: "Description",
      uploadFile: "Upload File",
      submit: "Submit",
      reset: "Reset",
      pleaseEnterWorkOrderTitle: "Please enter work order title",
      pleaseEnterOrderNo: "Please enter order no.",
      pleaseEnterDescription: "Please enter description",
      uploadSizeLimit: "The size of the uploaded file cannot exceed 10MB!",
    },
    workView: {
      workOrderInfo: "Work Order Info",
      workOrderTitle: "Work Order Title",
      workOrderNo: "Work Order No.",
      workOrderStatus: "Work Order Status",
      submitTime: "Submit Time",
      orderNo: "Order No.",
      description: "Description",
      attachment: "Attachment",
      feedbackRecords: "Feedback Records",
      noRecords: "No records yet~",
      replyInfo: "Reply Info",
      pleaseEnterDescription: "Please enter description",
      uploadFile: "Upload File",
      reply: "Reply",
      attachmentDownload: "Attachment Download",
      inProgress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
      replied: "Replied",
      uploadSizeLimit: "The size of the uploaded file cannot exceed 10MB!",
    },
  },
  product: {
    list: {
      projectName: "Project",
      lengthWidthHeight: "Length*Width*Height",
      weight: "Weight",
      freightClass: "Freight Class",
      palletType: "Pallet Type",
      productUnit: "Product Unit",
      cargoCategoryCode: "Cargo Category Code",
      subcategoryCode: "Subcategory Code",
      operation: "Operation",
      edit: "Edit",
      delete: "Delete",
      select: "Select",
      serialNo: "No.",
      search: "Search",
      reset: "Reset",
      addProduct: "Add Product",
      addProductDialog: "Add Product",
      editProductDialog: "Edit Product",
      pleaseEnterProjectName: "Please enter project name",
      confirmDelete: "Confirm deletion?",
      warmTip: "Warm Tip",
      yes: "Yes",
      no: "No",
    },
    form: {
      projectName: "Project Name",
      freightClass: "Freight Class",
      length: "Length",
      width: "Width",
      height: "Height",
      weight: "Weight",
      palletType: "Pallet Type",
      productUnit: "Product Unit",
      cargoCategoryCode: "Cargo Category Code",
      subcategoryCode: "Subcategory Code",
      submit: "Submit",
      reset: "Reset",
      pleaseEnterProjectName: "Please enter project name",
      pleaseSelectFreightClass: "Please select freight class",
      pleaseEnterLength: "Please enter length",
      pleaseEnterWidth: "Please enter width",
      pleaseEnterHeight: "Please enter height",
      pleaseEnterWeight: "Please enter weight",
      pleaseSelectPalletType: "Please select pallet type",
      pleaseSelectProductUnit: "Please select product unit",
      pleaseEnterCargoCategoryCode: "Please enter cargo category code",
      pleaseEnterSubcategoryCode: "Please enter subcategory code",
      setAsDefaultAddress: "Set as default address",
    },
  },
  price: {
    FBA: {
      fbaQuote: "FBA Quote",
      origin: "Origin",
      warehouseCode: "Repo. Cd",
      numberOfPallets: "Pallet Qty",
      calculateFreight: "Calculate Freight",
      pleaseEnterWarehouseCode: "Please enter Repo. Cd",
      pleaseEnterPalletCount: "Please enter Pallet Qty",
      amazonLtlFreight: "Amazon LTL Freight",
      truckingFee: "Trucking Fee",
      quoteExpirationTime: "Quote Expiration Time",
      palletSizeRequirement: "Pallet Size Requirement",
      serialNo: "No.",
      ftlRate28Pallets: "FTL Rate(28 Pallets)",
      warehouseEntryTime: "Warehouse Entry Time",
      to: "TO:",
      noData: "No Data",
      calculationSuccess: "Calculation successful",
      calculationFailed: "Calculation failed",
    },
    rateList: {
      quoteList: "Quote List",
      shippingAddress: "SHP-FM",
      receivingAddress: "SHP-TO",
      search: "Search",
      reset: "Reset",
      onlineQuote: "Online Quote",
      serialNo: "No.",
      quoteNo: "Quote No.",
      quoteDate: "Quote Date",
      operation: "Operation",
      edit: "Edit",
      delete: "Delete",
      pickupDate: "Pickup Date",
      deliveryDate: "Delivery Date",
      quotePrice: "Quote Price",
      confirmDelete: "Confirm deletion?",
      warmTip: "Warm Tip",
      pleaseEnterShippingAddress: "Please enter SHP-FM",
      pleaseEnterReceivingAddress: "Please enter SHP-TO",
    },
  },
  ltladdress: {
    list: {
      contactPerson: "Person",
      addressType: "Type",
      contactPhone: "Phone",
      search: "Search",
      reset: "Reset",
      addAddress: "Add Address",
      serialNo: "No.",
      addressName: "Address Name",
      address: "Address",
      shippingReceivingPlace: "Addr Tp",
      contactEmail: "Contact Email",
      isDefault: "Is Default",
      operation: "Operation",
      modify: "Modify",
      delete: "Delete",
      select: "Select",
      pleaseEnterContactPerson: "Please enter contact person",
      pleaseSelectAddressType: "Please select Addr Tp",
      pleaseEnterContactPhone: "Please enter contact phone",
      shippingAddress: "SHP-FM",
      receivingAddress: "SHP-TO",
      yes: "Yes",
      no: "No",
      confirmDelete: "Confirm deletion?",
      warmTip: "Warm Tip",
      addAddressTitle: "Add Address",
      editAddressTitle: "Edit Address",
      deleteSuccess: "Deletion successful",
      deleteFailed: "Deletion failed",
    },
    form: {
      shippingReceivingPlace: "Addr Tp",
      addressType: "Addr Tp",
      contactPerson: "Contact Person",
      contactEmail: "Contact Email",
      contactPhone: "Contact Phone",
      addressName: "Address Name",
      address1: "Address 1",
      address2: "Address 2",
      address3: "Address 3",
      zipCode: "ZIP Code",
      city: "City",
      stateProvince: "State/Province",
      country: "Country/Region",
      setAsDefaultAddress: "Set as Default Address",
      submit: "Submit",
      reset: "Reset",
      pleaseSelectShippingReceivingPlace: "Please select shipping/receiving place",
      originLocation: "Origin Location",
      destinationLocation: "Destination Location",
      pleaseSelectAddressType: "Please select Addr Tp",
      shippingAddress: "SHP-FM",
      receivingAddress: "SHP-TO",
      pleaseEnterContactPerson: "Please enter contact person",
      pleaseEnterContactEmail: "Please enter contact email",
      pleaseSelectPhoneCode: "Please select phone code",
      pleaseEnterContactPhone: "Please enter contact phone",
      pleaseEnterAddressName: "Please enter address name",
      pleaseEnterAddress1: "Please enter address 1",
      pleaseEnterAddress2: "Please enter address 2",
      pleaseEnterZipCode: "Please enter ZIP code",
      pleaseEnterCity: "Please enter city",
      pleaseSelectStateProvince: "Please select state/province",
      pleaseSelectCountry: "Please select country",
      submitSuccess: "Submission successful",
      submitFailed: "Submission failed",
      updateSuccess: "Update successful",
      updateFailed: "Update failed",
    },
  },
  ltlfinance: {
    finance: {
      announcementList: "Announcement List",
      time: "Time",
      startDate: "Start Date",
      endDate: "End Date",
      to: "To",
      query: "Search",
      reset: "Reset",
      serialNumber: "No.",
      orderNumber: "Order Number",
      consumptionType: "Consumption Type",
      paymentMethod: "Payment Method",
      transactionAmount: "Transaction Amount",
      accountBalance: "Account Balance",
      remarks: "Remarks",
      operator: "Operator",
      operationTime: "Operation Time",
      recharge: "Recharge",
      deduction: "Deduction",
      refund: "Refund",
    },
    invoice: {
      workOrderNo: "Order No.",
      search: "Search",
      reset: "Reset",
      pleaseEnterWorkOrderNo: "Please enter work order no.",
      serialNo: "No.",
      invoiceNo: "Invoice No.",
      platformOrderNo: "Platform Order No.",
      shippingAddress: "SHP-FM",
      receivingAddress: "SHP-TO",
      invoiceAmount: "Invoice Amount",
      operation: "Operation",
      view: "View",
      closeDetails: "Close Details",
    },
    recharge: {
      myWorkOrder: "My Work Orders",
      rechargeAmount: "Amount",
      approvalStatus: "Status",
      time: "Time",
      search: "Search",
      reset: "Reset",
      pleaseEnterRechargeAmount: "Please enter recharge amount",
      pleaseSelectApprovalStatus: "Please select approval status",
      pendingApproval: "Pending Approval",
      approved: "Approved",
      rejected: "Rejected",
      to: "To",
      startDate: "Start Date",
      endDate: "End Date",
      recharge: "Recharge",
      serialNo: "No.",
      amount: "Amount",
      remitter: "Remitter",
      remittanceBank: "Remittance Bank",
      remittanceAccount: "Remittance Account",
      wireTransferConfirmationNo: "Wire Transfer Confirmation No.",
      remittanceDate: "Remittance Date",
      remark: "Remark",
      file: "File",
      applicationDate: "Application Date",
      operation: "Operation",
      view: "View",
      reasonForRejection: "Reason for Rejection",
      applyForRecharge: "Apply for Recharge",
      close: "Close",
      addSuccess: "Add Success",
      editSuccess: "Edit Success",
    },
    rechargeForm: {
      payeeInfo: "Payee Information",
      payeeName: "Payee Name",
      payeeAddress: "Payee Address",
      accountNumber: "Account Number",
      payeeBank: "Payee's Bank",
      routingNumber: "Routing Number",
      remittanceCode: "Remittance Code",
      bankAddress: "Bank Address",
      referenceDocument: "Reference Document",
      replyInfo: "Reply Information",
      submittedAmount: "Submitted Amount",
      remitter: "Remitter",
      remittanceBank: "Remittance Bank",
      remittanceAccount: "Remittance Account",
      wireTransferConfirmationNo: "Wire Transfer Confirmation No.",
      remittanceDate: "Remittance Date",
      remark: "Remark",
      businessLicense: "Business License",
      save: "Save",
      pleaseEnterSubmittedAmount: "Please enter submitted amount",
      pleaseEnterRemitter: "Please enter remitter",
      pleaseEnterRemittanceBank: "Please enter remittance bank",
      pleaseEnterRemittanceAccount: "Please enter remittance account",
      pleaseEnterWireTransferNo: "Please enter wire transfer confirmation no.",
      pleaseSelectRemittanceDate: "Please select remittance date",
      uploadSizeLimit: "The size of the uploaded image cannot exceed 10MB!",
      submitSuccess: "Submit Success",
      submitFail: "Submit Fail",
    },
  },
  ltlnew: {
    list: {
      notificationList: "Notification List",
      notificationTime: "Time",
      search: "Search",
      reset: "Reset",
      to: "To",
      startDate: "Start Date",
      endDate: "End Date",
      serialNo: "No.",
      notificationTitle: "Notification Title",
      operation: "Operation",
      view: "View",
      notificationDetails: "Notification Details",
      close: "Close",
    },
  },
  ltlorder: {
    list: {
      allOrders: "All",
      pendingApproval: "Pending Approval",
      approvalRejected: "Approval Rejected",
      toBePicked: "To Be Picked",
      inTransit: "In Transit",
      delivered: "Delivered",
      orderCancelled: "Order Cancelled",
      refused: "Refused",
      quantity: "Quantity",
    },
    place: {
      ltl: "LTL",
      ftl: "FTL",
      shippingManagement: "Shipping Management",
      switchTransportType: "Switch Transport Type",
    },
    result: {
      carrierQuoteResult: "Carrier Quote Results",
      edit: "Edit",
      shippingAddress: "SHP-FM",
      receivingAddress: "SHP-TO",
      pickupDate: "Pickup Date",
      unit: "Unit",
      pkg: "Pkg",
      dimensions: "Dimensions",
      weightLb: "Weight(lb)",
      class: "Class",
      totalVolume: "TOTAL VOLUME(ft³)",
      totalWeightLb: "TOTAL WEIGHT(lb)",
      totalDensity: "TOTAL DENSITY(ft³)",
      sortBy: "Sort By",
      selectMethod: "Select Method",
      selectTime: "Select Time",
      priceAsc: "Price (Low to High)",
      transitTimeAsc: "Transit Time (Low to High)",
      oneDay: "1 Day",
      twoDays: "2 Days",
      threeDays: "3 Days",
      fourDays: "4 Days",
      carriers: "Carriers",
      pickupTime: "Pickup Time",
      estimatedTransitTime: "Estimated Transit Time (Business Days)",
      totalPrice: "Total Price",
      includingInsurance: "(Including Insurance: $ 0.00)",
      book: "Book",
      saveQuote: "Save Quote",
      cost: "Cost",
      description: "Description",
      amount: "Amount",
      orderAmount: "Order Amount",
      additionalFees: "Additional Fees",
      compensationStandard: "Compensation Standard",
      truckingCompensation: "Trucking Company Compensation",
      insuranceCompensation: "Insurance Company Compensation",
      day: "Day(s)",
    },
    orderView: {
      shipment: "Shipment",
      orderNumber: "Order No.",
      pendingReview: "Pending Review",
      pendingPickup: "Pending Pickup",
      inTransit: "In Transit",
      delivered: "Delivered",
      getLabel: "Get Label",
      shippingLocation: "Shipping Location",
      receivingLocation: "Receiving Location",
      track: "Track",
      goods: "Goods",
      freight: "Freight",
      carrierInfo: "Carrier Info",
      deductionReason: "Deduction Reason",
      deductionAmount: "Deduction Amount",
      certificateFile: "Certificate File",
      operatorInfo: "Operator Info",
      addressName: "Address Name",
      addressType: "Addr Tp",
      address: "Address",
      contact: "Contact",
      pickupTime: "Pickup Time",
      pickupCode: "Pickup Code",
      specialService: "Special Service",
      referenceNumber: "REF #",
      customerOrderNumber: "Customer Order No.",
      remarks: "Remarks",
      estimatedTransitTime: "Estimated Transit Time (Business Days)",
      deliveryCode: "Delivery Code",
      estimatedDeliveryTime: "Estimated Delivery Time",
      commodityName: "Commodity Name",
      pieces: "Pieces",
      pkg: "Pkg",
      perUnit: "Per Unit",
      totalWeight: "Total Weight",
      class: "Class",
      declared: "Declared",
      freightCost: "Freight Cost",
      orderAmount: "Order Amount",
      insuranceFee: "Insurance Fee",
      subsidyAmount: "Subsidy Amount",
      totalPrice: "Total Price",
      customFreightSystemCompany: "Custom Freight System Company",
      origin: "Origin",
      destination: "Destination",
      noData: "No Data~",
      getSuccess: "Get Success",
      noLabel: "No Label Available",
    },
    orderlist: {
      platformOrderNo: "Platform No.",
      customerOrderNo: "Customer No.",
      search: "Search",
      reset: "Reset",
      onlineQuote: "Online Quote",
      serialNo: "No.",
      basicInfo: "Basic Info",
      orderDetails: "Order Details",
      shippingInfo: "Shipping Info",
      orderInfo: "Order Info",
      operation: "Operation",
      cancelOrder: "Cancel Order",
      copySuccess: "Copy Success",
      confirmCancelOrder: "Are you sure to cancel the order?",
      warmTip: "Warm Tip",
      createOrder: "Create Order",
      details: "Details",
      carrier: "Carrier",
      status: "Status",
      mode: "Mode",
      shippingTime: "Shipping Time",
      orderSource: "Order Source",
      orderFile: "Order File",
      orderType: "Order Type",
      goodsInfo: "Goods Info",
      specialService: "Special Service",
      no: "None",
      freight: "Freight",
      orderAmount: "Order Amount",
      insuranceFee: "Insurance Fee",
      subsidyAmount: "Subsidy Amount",
      totalPrice: "Total Price",
      website: "Website",
      ordinaryFile: "Ordinary File",
      toBeReviewed: "Pending Review",
      reviewRejected: "Review Rejected",
      pendingPickup: "Pending Pickup",
      inTransit: "In Transit",
      delivered: "Delivered",
      orderCancelled: "Order Cancelled",
      refused: "Refused",
      createTime: "Create Time",
      account: "Account",
      queryCode: "Query Code",
    },
    olPlace: {
      addressInfo: "Address Information",
      shippingAddress: "SHP-FM",
      addressType: "Addr Tp",
      receivingAddress: "SHP-TO",
      pickupDate: "Pickup Date",
      shippingInfo: "Shipping Information",
      howToFillSize: "How to Fill in Dimensions Correctly",
      selectProduct: "Select Product",
      parcelInfo: "Parcel Information",
      commodityName: "Commodity Name",
      commodityQuantity: "Commodity Quantity",
      commodityUnit: "Commodity Unit",
      palletQuantity: "Pallet Quantity",
      palletType: "Pallet Type",
      goodsValue: "Goods Value",
      length: "Length",
      width: "Width",
      height: "Height",
      totalWeight: "Total Weight",
      grade: "Grade",
      nmfcNumber: "NMFC Number",
      hazardousGoodsUN: "Hazardous Goods UN No.",
      hazardousGoodsClass: "Hazardous Goods Class",
      hazardousGoodsQuantity: "Hazardous Goods Quantity",
      isToxic: "Is Toxic",
      emergencyContact: "Emergency Contact",
      phoneNumber: "Phone Number",
      isHazardousGoods: "Is Hazardous Goods",
      totalVolume: "Total Volume",
      totalDensity: "Total Density",
      getQuote: "Get Quote",
      pleaseSelectShippingAddress: "Please select SHP-FM",
      pleaseSelectAddressType: "Please select Addr Tp",
      pleaseSelectReceivingAddress: "Please select SHP-TO",
      pleaseSelectPickupDate: "Please select pickup date",
      pleaseEnterCommodityName: "Please enter commodity name",
      pleaseEnterCommodityQuantity: "Please enter commodity quantity",
      pleaseSelectCommodityUnit: "Please select commodity unit",
      pleaseEnterPalletQuantity: "Please enter pallet quantity",
      pleaseSelectPalletType: "Please select pallet type",
      pleaseEnterGoodsValue: "Please enter goods value",
      pleaseEnterLength: "Please enter length",
      pleaseEnterWidth: "Please enter width",
      pleaseEnterHeight: "Please enter height",
      pleaseEnterWeight: "Please enter weight",
      pleaseEnterHazardousGoodsUN: "Please enter hazardous goods UN number",
      pleaseSelectHazardousGoodsClass: "Please select hazardous goods class",
      pleaseSelectIsToxic: "Please select if toxic",
      pleaseEnterEmergencyContact: "Please enter emergency contact",
      pleaseEnterPhoneNumber: "Please enter phone number",
      quoteSuccess: "Quote obtained successfully",
      quoteFail: "Failed to obtain quote",
    },
    zlPlace: {
      title: {
        addressInfo: "Address Information",
        shipmentInfo: "Shipment Information",
      },
      label: {
        originAddress: "SHP-FM",
        addressType: "Addr Tp",
        equipmentCategory: "Equipment Category",
        destinationAddress: "SHP-TO",
        pickupDate: "Pickup Date",
        commodityName: "Commodity Name",
        commodityQuantity: "Commodity Quantity",
        commodityUnit: "Commodity Unit",
        palletQuantity: "Pallet Quantity",
        palletType: "Pallet Type",
        cargoValue: "Declared Value",
        length: "Length",
        width: "Width",
        height: "Height",
        totalWeight: "Total Weight",
        grade: "Class",
        nmfc: "NMFC",
        hazmatUNNumber: "Hazmat UN Number",
        hazmatClass: "Hazmat Class",
        hazmatQuantity: "Hazmat Quantity",
        isToxic: "Is Toxic",
        emergencyContact: "Emergency Contact",
        mobilePhone: "Phone",
        isHazmat: "Is Hazardous Material",
      },
      placeholder: {
        selectOriginAddress: "Please select SHP-FM",
        selectAddressType: "Please select Addr Tp",
        selectEquipmentCategory: "Please select equipment category",
        selectDestinationAddress: "Please select SHP-TO",
        selectPickupDate: "Please select pickup date",
      },
      options: {
        toxic: {
          nonToxic: "Non-toxic",
          toxic: "Toxic",
        },
      },
      unit: {
        inLb: "in/lb",
        cmKg: "cm/kg",
        volume: "ft³",
        weight: "lb",
        density: "lb/ft³",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "kg",
      },
      button: {
        selectProduct: "Select Product",
        getQuote: "Get Quote",
        reset: "Reset",
      },
      packageInfo: "Package Info",
      calculation: {
        totalVolume: "Total Volume",
        totalWeight: "Total Weight",
        totalDensity: "Total Density",
      },
      validation: {
        selectOriginAddress: "Please select SHP-FM",
        selectAddressType: "Please select Addr Tp",
        selectDestinationAddress: "Please select SHP-TO",
        selectPickupDate: "Please select pickup date",
        enterCommodityName: "Please enter commodity name",
        enterCommodityQuantity: "Please enter commodity quantity",
        selectCommodityUnit: "Please select commodity unit",
        enterPalletQuantity: "Please enter pallet quantity",
        selectPalletType: "Please select pallet type",
        enterCargoValue: "Please enter cargo value",
        enterLength: "Please enter length",
        enterWidth: "Please enter width",
        enterHeight: "Please enter height",
        enterWeight: "Please enter weight",
        enterHazmatUNNumber: "Please enter hazmat UN number",
        selectHazmatClass: "Please select hazmat class",
        selectIsToxic: "Please select if toxic",
        enterEmergencyContact: "Please enter emergency contact",
        enterMobilePhone: "Please enter phone",
      },
      message: {
        quoteSuccess: "Quote retrieved successfully",
        getQuoteFailed: "Failed to get quote",
      },
    },
    order: {
      title: {
        shipperInfo: "Shipper Information",
        consigneeInfo: "Consignee Information",
        shipmentInfo: "Shipment Information",
        summary: "Summary",
        selectProduct: "Select Product",
      },
      label: {
        addressName: "Address Name",
        addressType: "Addr Tp",
        specialRequirements: "Special Requirements",
        address1: "Address 1",
        address2: "Address 2",
        address3: "Address 3",
        zipCode: "Zip Code",
        city: "City",
        state: "State",
        country: "Country/Region",
        pickupCode: "Pickup Code",
        pickupTimeSlot: "Pickup Time Slot",
        contactPerson: "Contact Person",
        contactPhone: "Contact Phone",
        contactEmail: "Contact Email",
        orderNumber: "Order Number",
        referenceNumber: "Reference Number",
        remarks: "Remarks",
        deliveryCode: "Delivery Code",
        deliveryTimeSlot: "Delivery Time Slot",
        commodityName: "Commodity Name",
        commodityQuantity: "Commodity Quantity",
        commodityUnit: "Commodity Unit",
        palletQuantity: "Pallet Quantity",
        palletType: "Pallet Type",
        cargoValue: "Declared Value",
        length: "Length",
        width: "Width",
        height: "Height",
        totalWeight: "Total Weight",
        grade: "Class",
        nmfc: "NMFC",
        hazmatUNNumber: "Hazmat UN Number",
        hazmatClass: "Hazmat Class",
        hazmatQuantity: "Hazmat Quantity",
        isToxic: "Is Toxic",
        emergencyContact: "Emergency Contact",
        mobilePhone: "Phone",
        isHazmat: "Is Hazardous Material",
        packageInfo: "Package Info",
        carrierPlatform: "Carrier Platform",
        originLocation: "Origin",
        destinationLocation: "Destination",
        pickupDate: "Pickup Date",
        estimatedTransitTime: "Est. Transit Time (Business Days)",
        totalPrice: "Total Price",
        paymentMethod: "Payment Method",
        accountBalance: "Account Balance",
      },
      placeholder: {
        enterAddressName: "Please enter address name",
        selectAddressType: "Please select Addr Tp",
        selectSpecialRequirements: "Please select special requirements",
        enterAddress1: "Please enter address 1",
        enterAddress2: "Please enter address 2",
        enterAddress3: "Please enter address 3",
        enterZipCode: "Please enter zip code",
        enterCity: "Please enter city",
        enterState: "Please enter state",
        enterCountry: "Please enter country",
        enterPickupCode: "Please enter pickup code",
        startTime: "Start Time",
        endTime: "End Time",
        enterContactPerson: "Please enter contact person",
        enterContactPhone: "Please enter contact phone",
        selectCountry: "Please select",
        enterContactEmail: "Please enter contact email",
        enterOrderNumber: "Please enter order number",
        enterReferenceNumber: "Please enter reference number",
        enterRemarks: "Please enter remarks",
        enterDeliveryCode: "Please enter delivery code",
        enterCommodityName: "Please enter commodity name",
        enterCommodityQuantity: "Please enter quantity",
        selectCommodityUnit: "Please select unit",
        enterPalletQuantity: "Please enter pallet quantity",
        selectPalletType: "Please select pallet type",
        enterCargoValue: "Please enter declared value",
        enterLength: "Please enter length",
        enterWidth: "Please enter width",
        enterHeight: "Please enter height",
        enterWeight: "Please enter weight",
        enterHazmatUNNumber: "Please enter hazmat UN number",
        selectHazmatClass: "Please select hazmat class",
        selectIsToxic: "Please select if toxic",
        enterEmergencyContact: "Please enter emergency contact",
        enterMobilePhone: "Please enter phone",
      },
      unit: {
        inLb: "in/lb",
        cmKg: "cm/kg",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "kg",
        volume: "ft³",
        density: "lb/ft³",
        day: "Days",
        currency: "$",
      },
      options: {
        toxic: {
          nonToxic: "Non-toxic",
          toxic: "Toxic",
        },
        country: {
          unitedStates: "United States",
        },
      },
      calculation: {
        totalVolume: "Total Volume",
        totalWeight: "Total Weight",
        totalDensity: "Total Density",
      },
      button: {
        selectProduct: "Select Product",
        bookShipment: "Book Shipment",
        reestimate: "Re-estimate Shipment",
      },
      validation: {
        enterAddressName: "Please enter address name",
        selectAddressType: "Please select Addr Tp",
        enterAddress1: "Please enter address 1",
        enterCity: "Please enter city",
        selectPickupTimeSlot: "Please select pickup time slot",
        enterPickupCode: "Please enter pickup code",
        enterContactPerson: "Please enter contact person",
        enterContactPhone: "Please enter contact phone",
        enterContactEmail: "Please enter contact email",
        enterOrderNumber: "Please enter order number",
        enterReferenceNumber: "Please enter reference number",
        enterRemarks: "Please enter remarks",
        enterDeliveryCode: "Please enter delivery code",
        selectDeliveryTimeSlot: "Please select delivery time slot",
        enterCommodityName: "Please enter commodity name",
        enterCommodityQuantity: "Please enter quantity",
        selectCommodityUnit: "Please select unit",
        enterPalletQuantity: "Please enter pallet quantity",
        selectPalletType: "Please select pallet type",
        enterCargoValue: "Please enter declared value",
        enterLength: "Please enter length",
        enterWidth: "Please enter width",
        enterHeight: "Please enter height",
        enterWeight: "Please enter weight",
        enterHazmatUNNumber: "Please enter hazmat UN number",
        selectHazmatClass: "Please select hazmat class",
        selectIsToxic: "Please select if toxic",
        enterEmergencyContact: "Please enter emergency contact",
        enterMobilePhone: "Please enter phone",
      },
      message: {
        getQuoteFailed: "Failed to get quote",
      },
    },
  },
};
